import React, { useState, useContext, useReducer } from "react";

import GlobalContext                      from "../../isp._comun/iu/contexto/GlobalContext";
import * as TipoDeError                   from "../../isp._comun/services/Errores";
// import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import ServicioDeQueryDePlanes             from "../../isp.žapi.planes/ServiceQueryPlanes";


import QueryPlanReducer from "../reductores/QueryPlanReducer";
import CargaDePlanesBuscados from "../reductores/acciones/dispatch/CargaDePlanesBuscados";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";

import DialogoQueryPlanesLayout from "./layouts/DialogoQueryPlanesLayout";
import ComandoAPI from "./ComandoAPI";

const DialogoQueryPlanes = ({ ventana }) => {
    const { notificar, handleErroresExtraEnPrincipal } = useContext(GlobalContext);

    const [estadoQ, dispatchQ] = useReducer(QueryPlanReducer, {
        data: [],
        params: {},
        flag: {
            procesandoComando: false,
            procesandoBusquedaUnSoloCliente: false,
        },
        // idClienteSelec: null,
    });

    const buscarPlanesCommand = new ComandoAPI();
    // buscarPlanesCommand.ejecutar = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
    buscarPlanesCommand.ejecutar = async (paramsQuery) => {
    // const buscarPlanes = useHandlerDeComandoConSesionActiva(async (paramsQuery) => {
        /* const clienteAFactPorActualizar = {
            id: estadoDCF.domain.screen.idCliente,
            data: estadoDCF.domain.update,
        }; */

        try {
            buscarPlanesCommand.servicio = new ServicioDeQueryDePlanes();
            const respuestaQuery = await buscarPlanesCommand.servicio.ejecutar(paramsQuery);
            /* const respuestaQuery = await new ServicioDeQueryDeClientesAFacturar().ejecutar(
                paramsQuery
            ); */
            // dispatchQ(new CargaDePlanesBuscados(respuestaQuery.clientes));
            dispatchQ(new CargaDePlanesBuscados(respuestaQuery.planes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchQ(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    }
    // });

    

    return (
        <DialogoQueryPlanesLayout
            ventana={ventana}
            dispatchQ={dispatchQ}
            estadoQ={estadoQ}
            buscarPlanes={buscarPlanesCommand}
            // buscarPlanes={buscarPlanes}

        />
    );
};

export default DialogoQueryPlanes;
